<template lang="pug">
div
    el-dialog.resultado-diagnostico(
        :visible.sync='mostrarDialogCamadas',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        fullscreen
    )
        .lista
            .lista__header
                h2.cursor-pointer(@click='mostrarDialogCamadas = false')
                    i.el-icon-arrow-left.voltar
                    | {{ diagnosticoPessoa ? 'Análise do Fornecedor' : 'Análise do imóvel' }}
                BaseButton(
                    v-if='!diagnosticoPessoa',
                    type='primary',
                    @click='baixarAnalise',
                    :icon='baixandoAnalise ? "el-icon-loading" : "el-icon-download"',
                    :disabled='baixandoAnalise'
                ) {{ baixandoAnalise ? 'Baixando' : 'Baixar' }}

            .lista__content
                .lista__grupo(
                    v-for='(grupo, index) in diagnosticoSelecionado.grupo'
                )
                    label.font-weight-bold {{ grupo.titulo }} - última atualização {{ grupo.dataAtualizacao }}
                    div
                        span {{ grupo.nome }}
                    DiagnosticoSocioambiental(
                        :dadosConsulta='grupo',
                        :indexCollapse='index',
                        :cpfCnpj='grupo.documento',
                        :habilitar-sinal-aviso='false',
                        :habilitar-inibicao-camada='habilitarInibicaoCamada',
                        @index-aberto='atualizarRestricaoMapa',
                        @inibir-restricao='abrirModalInibirRestricao',
                        @inibir-restricoes-em-lote='abrirModalInibirRestricoesEmLote',
                        @editar-justificativa='abrirModalEditarJustificativa'
                    )
        .mapa
            mapa(
                :showStatesLayers='false',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaAnaliseSocioambientalOperacaoCdaWa"',
                ref='mapa',
                :menuMaior='true',
                :doubleMapOnPage='true'
            )

    ModalInibirRestricoesCdaWa(
        ref='modalInibirRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao',
        :codigo-camada='inibicao.codigoCamada',
        @atualizar-restricao-inibido='atualizarRestricaoInibido'
    )
    ModalInibirRestricoesEmLoteCdaWa(
        ref='modalInibirRestricoesEmLote',
        :id-operacao='inibicaoEmLote.idOperacao',
        :restricoes-selecionadas='inibicaoEmLote.restricoesSelecionadas',
        :camada='inibicaoEmLote.camada',
        @atualizar-restricoes-inibidas='atualizarRestricoesInibidas'
    )
    ModalJustificativaRestricoesCdaWa(
        ref='modalJustificativaRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao'
    )
    ModalEdicaoRestricoesCdaWa(
        ref='modalEdicaoRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao',
        :codigo-camada='inibicao.codigoCamada'
    )
</template>

<script>
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import DiagnosticoPDF from '@/views/diagnostico-socioambiental/DiagnosticoSocioambiental.vue';
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';
import ModalInibirRestricoesCdaWa from '@/components/operacao-cda-wa/restricoes/ModalInibirRestricoesCdaWa.vue';
import ModalInibirRestricoesEmLoteCdaWa from '@/components/operacao-cda-wa/restricoes/ModalInibirRestricoesEmLoteCdaWa.vue';
import ModalJustificativaRestricoesCdaWa from '@/components/operacao-cda-wa/restricoes/ModalJustificativaRestricoesCdaWa.vue';
import ModalEdicaoRestricoesCdaWa from '@/components/operacao-cda-wa/restricoes/ModalEdicaoRestricoesCdaWa.vue';
import L from 'leaflet';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

import { mapGetters } from 'vuex';
import { connect, disconnect, subscribe } from '@/utils/websocket';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import { retryOperation } from '@/utils/retry-operation';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalResultadoDiagnosticoOperacaoCdaWa',
    components: {
        ModalEdicaoRestricoesCdaWa,
        ModalInibirRestricoesCdaWa,
        ModalInibirRestricoesEmLoteCdaWa,
        ModalJustificativaRestricoesCdaWa,
        Mapa,
        DiagnosticoSocioambiental,
        DiagnosticoPDF,
        BaseButton
    },

    props: {
        habilitarInibicaoCamada: {
            default: false,
            required: false
        },

        carSelecionadoAnalise: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            restricao: null,
            restricoes: null,
            inibicao: {
                idOperacao: '',
                idRestricao: '',
                codigoCamada: ''
            },
            inibicaoEmLote: {
                idOperacao: '',
                restricoesSelecionadas: [],
                camada: {}
            },
            mostrarDialogCamadas: false,
            areasRestricao: [],
            diagnosticoSelecionado: [],
            collapsesAbertos: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: true,
                    bufferControl: false,
                    uploadFileControl: false,
                    popupControl: false,
                    camadasBaseControl: false,
                    botaoAnotacoes: false,
                    ferramentasControl: false
                },
                historicoMonitoramento: false,
                inspecionar: true,
                diagnostico: false
            },
            baixandoAnalise: false,
            car: '',
            diagnosticoPessoa: false
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        atualizarRestricaoMapa(restricao, indexGrupo, indexCamada) {
            this.areasRestricao = [];

            /**
             * Remove o último quando for dentro do mesmo collapse
             */
            const mesmogGrupo = this.collapsesAbertos.find(
                c => c.indexGrupo === indexGrupo
            );
            if (mesmogGrupo) {
                this.layersMaps = this.layersMaps.filter(
                    l => l.tagRestricao !== mesmogGrupo.tag
                );
                this.collapsesAbertos = this.collapsesAbertos.filter(
                    l => l.tag !== mesmogGrupo.tag
                );
            }

            this.layersMaps = this.layersMaps.filter(
                l => !l.name.includes('CentroidDiagnostico')
            );

            /**
             * Quando possuir indexCamada é por que o collapse está sendo aberto
             * Nesse caso a geometria é adicionada no mapa
             */
            if (indexCamada !== '') {
                const grupoSelecionado =
                    this.diagnosticoSelecionado.grupo[indexGrupo];
                const diagnosticoSelecionado =
                    grupoSelecionado.diagnosticos ||
                    grupoSelecionado.diagnostico;
                this.areasRestricao = diagnosticoSelecionado[
                    indexCamada
                ].resultados.filter(
                    resultado => resultado.geometria || resultado.geometry
                );

                const tagRestricaoAdd = `${indexGrupo}-${indexCamada}-restricao`;
                this.collapsesAbertos.push({
                    indexGrupo,
                    indexCamada,
                    tag: tagRestricaoAdd
                });

                this.mostrarAreasDiagnosticoNoMapa(tagRestricaoAdd, restricao);
            }
        },

        abrirModal(diagnosticoProtocolo) {
            this.mostrarDialogCamadas = true;
            this.layersMaps = [];
            this.areasRestricao = [];
            this.collapsesAbertos = [];
            this.diagnosticoSelecionado = null;
            this.diagnosticoPessoa = diagnosticoProtocolo.diagnosticoPessoa;

            diagnosticoProtocolo.grupo.forEach(grupo => {
                grupo.diagnostico.forEach(diagnostico => {
                    if (diagnostico.camada.nome === 'Áreas embargadas') {
                        diagnostico.camada.nome = 'Áreas embargadas (IBAMA)';
                    } else if (
                        diagnostico.camada.nome === 'Monitoramento Desmatamento'
                    ) {
                        diagnostico.camada.nome = 'Desmatamento Lyra';
                    }
                });
            });
            this.diagnosticoSelecionado = diagnosticoProtocolo;

            this.adicionaGeometriasFixasNoMapa(diagnosticoProtocolo);
        },

        adicionaGeometriasFixasNoMapa(diagnosticoProtocolo) {
            if (diagnosticoProtocolo.geometria) {
                this.layersMaps.push({
                    style: getEstiloGeometria('operacaoTerritorio'),
                    geoJson: diagnosticoProtocolo.geometria,
                    name: 'territorio'
                });
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, restricao) {
            this.areasRestricao.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                const pin = L.icon({
                    iconUrl:
                        'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico_${index}`,
                    icon: pin,
                    geoJson: centroidFromGeoJSON.get(geometria)
                });

                let layerAreaDiagnostico;
                if (
                    restricao &&
                    restricao.index === index &&
                    restricao.overOrLeave === 'over'
                ) {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'orange',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: area.geometria || area.geometry
                    };
                } else {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: area.geometria || area.geometry
                    };
                }

                this.layersMaps.push(layerAreaDiagnostico);
            });
        },

        async baixarAnalise() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        'Não foi possível se conectar na api para realizar o download do pdf!'
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = this.$t('mensagens.diagnosticoSocioambiental.pdfTitulo');
                            link.href = linkSource;
                            link.download = fileName;
                            link.click();
                            link.remove();
                        } else {
                            this.$notify.error({
                                message: 'Não foi possível exportar o pdf!'
                            });
                        }
                        this.baixandoAnalise = false;
                        disconnect();
                    }
                );

                this.baixandoAnalise = true;

                const params = {
                    idTerritorio: null,
                    tipoDocumento: 'CODIGOCAR',
                    documento: this.carSelecionadoAnalise,
                    camadas: [],
                    buffer: null,
                    nomeArquivo: null
                };

                const dados = [];
                dados.push(params);

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    dados,
                    5000,
                    10
                );
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível exportar o pdf!'
                });
                disconnect();
            }
        },

        atualizarRestricaoInibido() {
            this.restricao.inibido = true;
            this.diagnosticoSelecionado.grupo.forEach(grupo => {
                grupo.diagnostico.forEach(camada => {
                    camada.resultados
                        .filter(resultado => resultado.id === this.restricao.id)
                        .forEach(camadaIgual => {
                            camadaIgual.inibido = true;
                        });
                });
            });
            this.$emit('atualizarDadosMonitoramento');
        },
        atualizarRestricoesInibidas(restricoes) {
            this.restricoes = restricoes;
            this.restricoes.forEach(restricao => {
                restricao.inibido = true;
                this.diagnosticoSelecionado.grupo.forEach(grupo => {
                    grupo.diagnostico.forEach(camada => {
                        camada.resultados
                            .filter(resultado => resultado.id === restricao.id)
                            .forEach(camadaIgual => {
                                camadaIgual.inibido = true;
                            });
                    });
                });
            });

            this.$emit('atualizarDadosMonitoramento');
        },

        abrirModalInibirRestricoesEmLote(restricoes, diagnostico) {
            this.inibicaoEmLote.restricoesSelecionadas = restricoes.map(
                restricao => ({ ...restricao, operacoes: [] })
            );
            this.inibicaoEmLote.camada = diagnostico.camada;
            this.inibicaoEmLote.idOperacao = this.$route.params.idOperacao;
            this.$refs.modalInibirRestricoesEmLote.mostrarDialog = true;
        },

        abrirModalInibirRestricao(restricao, diagnostico) {
            if (restricao.id === null) {
                this.$notify.info({
                    message:
                        'Não foi possível encontrar o código para a restrição selecionada.'
                });
            } else {
                this.restricao = restricao;

                if (!restricao.inibido) {
                    this.inibicao.idRestricao = restricao.id;
                    this.inibicao.codigoCamada = diagnostico.camada.codigo;
                    this.inibicao.idOperacao = this.$route.params.idOperacao;
                    this.$refs.modalInibirRestricao.mostrarDialog = true;
                } else {
                    this.inibicao.idRestricao = restricao.id;
                    this.inibicao.idOperacao = this.$route.params.idOperacao;
                    this.$refs.modalJustificativaRestricao.mostrarDialog = true;
                }
            }
        },
        abrirModalEditarJustificativa(restricao, diagnostico) {
            this.inibicao.idRestricao = restricao.id;
            this.inibicao.codigoCamada = diagnostico.camada.codigo;
            this.inibicao.idOperacao = this.$route.params.idOperacao;
            this.$refs.modalEdicaoRestricao.mostrarDialog = true;
        }
    }
};
</script>

<style lang="scss">
.resultado-diagnostico {
    .lista {
        display: flex;
        flex-direction: column;
        width: 35%;
        gap: 20px;
        max-height: 100vh;
        padding: 20px 10px 20px 20px;

        .lista__header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .voltar {
                cursor: pointer;
                margin-right: 10px;
            }

            h2.cursor-pointer {
                color: var(--primary-font-color);
                margin-bottom: 0 !important;
            }
        }

        .lista__content {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 90vh;
            overflow-y: scroll;
        }

        .lista__grupo {
            label {
                color: var(--primary);
            }
        }
    }

    .mapa {
        width: 100%;
        height: 100vh;
        border-radius: 0;
    }

    .el-dialog__body {
        display: flex;
        padding: initial !important;
    }

    .el-dialog__header {
        padding: initial;
    }
}
</style>
